// src/locales/en/messageCenterShifts.js
export const messageCenterShifts = {
  pageTitle: 'Message Center Shifts',
  pageDescription: 'Schedule shifts, assign a leader and staff, and track working hours',
  newShift: 'New Shift',
  editShift: 'Edit Shift',
  createShift: 'Create Shift',
  saveShift: 'Save Shift',
  shiftDate: 'Shift Date',
  shiftType: 'Shift Type',
  shiftLeader: 'Shift Leader',
  targetSalesValue: 'Target Sales Value',
  commissionFlags: 'Commission Flags',
  excludeAllFromCommission: 'Exclude all staff from commission',
  excludeLeaderFromCommission: 'Exclude leader from commission',
  shiftStaff: 'Shift Staff',
  addStaff: 'Add Staff',
  staffMember: 'Staff Member',
  startTime: 'Start Time',
  endTime: 'End Time',
  staffCount: 'Staff Count',
  achievedSalesValue: 'Achieved Sales',
  totalCommission: 'Total Commission',
  detailsPageTitle: 'Shift Details',
  detailsPageDescription: 'Commission breakdown, orders, and performance summary for this shift',
  totalOrders: 'Total Orders',
  dispatchedOrders: 'Dispatched Orders',
  settledOrders: 'Settled Orders',
  salesValue: 'Sales Value',
  orderQuantity: 'Order Quantity',
  itemQuantity: 'Item Quantity',
  staffCommissionBreakdown: 'Staff Commission Breakdown',
  shiftOrders: 'Shift Orders',
  noOrdersForShift: 'No orders belong to this shift',
  failedToLoadShiftDetails: 'Failed to load shift details',
  failedToLoadShiftOrders: 'Failed to load shift orders',
  hours: 'Hours',
  courierStatus: 'Courier Status',
  orderItems: 'Order Items',
  itemsQty: 'Qty',
  commissionCalculation: 'Commission Calculation',
  amountPerUnit: 'Amount Per Unit',
  slabQty: 'Slab Qty',
  slabTotal: 'Slab Total',
  searchShiftOrders: 'Search order number, customer, airwaybill, or phone...',
  orderStatusFilter: 'Order Status',
  courierStatusFilter: 'Courier Status',
  allStatuses: 'All statuses',
  searchStatuses: 'Search statuses...',
  filterByShiftType: 'Filter by Shift Type',
  filterByLeader: 'Filter by Leader',
  allShiftTypes: 'All Shift Types',
  allLeaders: 'All Leaders',
  dateFrom: 'Date From',
  dateTo: 'Date To',
  filterByDateRange: 'Shift Date Range',
  allShiftDates: 'All shift dates',
  noShiftsFound: 'No shifts found',
  noShiftsFoundDescription: 'Try adjusting your filters or create a new shift',
  noShiftsYet: 'No shifts scheduled yet',
  noShiftsYetDescription: 'Create your first shift to get started',
  shiftCreatedSuccess: 'Shift created successfully',
  shiftUpdatedSuccess: 'Shift updated successfully',
  failedToLoadShifts: 'Failed to load shifts',
  failedToLoadShiftTypes: 'Failed to load shift types',
  failedToLoadUsers: 'Failed to load business users',
  failedToSaveShift: 'Failed to save shift',
  timesResetNote: 'Start/end times have been updated to match the selected shift type defaults.',
  selectShiftType: 'Select a shift type',
  selectLeader: 'Select a shift leader',
  selectUser: 'Select a user',
  removeStaff: 'Remove',
  duplicateStaffWarning: 'This user has already been added to this shift',
  leaderStaffRowUpdatedNotice: 'The shift leader\'s staff entry has been updated to match the new leader',
  leaderRowLocked: 'This entry is managed automatically because this user is the shift leader',
  edit: 'Edit',
  viewDetails: 'View Details',
  estimate: 'Estimate',
  estimateNote: 'Live estimate — commission values will be final once the shift is finalized',
  selectTime: 'Select time',
  targetSalesValuePlaceholder: 'e.g. 500000',
  validation: {
    shiftDateRequired: 'Shift date is required',
    shiftTypeRequired: 'Shift type is required',
    shiftLeaderRequired: 'Shift leader is required',
    targetSalesValueRequired: 'Target sales value is required',
    targetSalesValueInvalid: 'Target sales value must be a valid positive number',
    staffUserRequired: 'Please select a staff member for every row',
    staffTimeRequired: 'Start and end time are required for every staff row',
    fixErrors: 'Please fix the highlighted errors before saving',
  },
};
